import { render, staticRenderFns } from "./TimeCard.vue?vue&type=template&id=deb0274c&scoped=true"
import script from "./TimeCard.vue?vue&type=script&lang=ts"
export * from "./TimeCard.vue?vue&type=script&lang=ts"
import style0 from "./TimeCard.vue?vue&type=style&index=0&id=deb0274c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb0274c",
  null
  
)

export default component.exports